<template>
  <el-header class="flex flex_x_bten">
    <div class="logo-Img">
      <img :src="configureInfos.logo" height="50">
    </div>

    <div class="head-icon">
      <div class="fr">
        <i class="fs24 c_fff el-icon-user"></i>
        <el-dropdown placement="bottom-end" class="fr">
          <span class="el-dropdown-link c_fff">
            {{ adduser }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link :to="{ path: '/password?title=修改密码' }">修改密码</router-link>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </el-header>
</template>

<script>
export default {
  data() {
    return {
      adduser: ""
    };
  },
  created() {
    this.queryCommercial();
    // 获取文件模板
    this.fileTemplate()
  },
  mounted() {

  },
  methods: {
    async queryCommercial() {
      // 查询商户信息
      let datum = await this.service.User.CommercialTenant();
      if (datum.code == 0) {
        this.adduser = datum.data.name + "（" + datum.data.nickName + "）";
        sessionStorage.setItem("datum", JSON.stringify(datum.data));
      } else {
        tipsTemplate(datum.msg, "error", "1");
      }

      let detail = await this.service.individualCenter.MerchantRegulate({
        merchantId: JSON.parse(sessionStorage.getItem("datum")).id
      });
      if (detail.code == 0) {
        sessionStorage.setItem("customExtraVO", JSON.stringify(detail.data.customExtraVO));
      } else {
        tipsTemplate(detail.msg, "error", "1");
      }
    },
    // 获取文件模板
    async fileTemplate() {
      // 对私
      let fileData1 = await this.service.User.dataDictByPara({ key: "PRIVATE_PAY_TEMPLATE" });
      if (fileData1.code == 0) {
        configureInfos.mobUrlOrder[0].url = fileData1.data;
      }
      // 对公
      let fileData2 = await this.service.User.dataDictByPara({ key: "PUBLIC_PAY_TEMPLATE" });
      if (fileData2.code == 0) {
        configureInfos.mobUrlOrder[1].url = fileData2.data;
      }
      // 邀请
      let fileData3 = await this.service.User.dataDictByPara({ key: "INVITE_USER_TEMPLATE" });
      if (fileData3.code == 0) {
        configureInfos.mobUrlUser = fileData3.data;
      }
    },
    handleLogout() {
      let _this = this;
      tipsTemplate("是否退出登录?", "warning", "3", "确定", "取消", function () {
        _this.signOut();
      });
    },
    async signOut() {
      let datum = await this.service.User.LogOut();
      if (datum.code == 0) {
        this.$router.replace("/");
        sessionStorage.setItem("token", "");
        sessionStorage.setItem("datum", "");
        sessionStorage.setItem("taskSwitch", "");
        sessionStorage.setItem("optionAside", "");
        sessionStorage.setItem("bts_M", "");
        sessionStorage.setItem("customExtraVO", "");
        sessionStorage.setItem("datum", "");
      } else {
        tipsTemplate(datum.msg, "error", "1");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  height: 60px !important;
  line-height: 60px;
  padding-top: 5px;
  position: relative;
  z-index: 2000;
  background-color: #012953;

  .logo-Img {
    text-align: center;
    line-height: 1;
    padding: 0px 0;
    height: 50px;

    >img {
      // width: 100%;
      height: 100%;
    }

    >h1 {
      line-height: 22px;
    }
  }

  i {
    margin-right: 22px;
    cursor: pointer;
  }

  .head-icon {
    >div {
      height: 50px;

      .el-dropdown {
        height: 50px;
        margin-top: -4px;
        cursor: pointer;
      }
    }
  }
}

/deep/.el-dropdown-menu {
  width: 150px;
  text-align: center;
  z-index: 3001 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/comHeader.vue